import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {isStudent} from '../../../utils/userUtility';
import WhiteBoard from './WhiteBoard';
import classNames from 'classnames';

@observer
class WhiteBoardWrapper extends Component {
    componentDidCatch(err, info) {
        console.log(err);
    }

    render() {
        const {id, width, height, imageUrl, rotate, canvas, cancelCanvas, isNotation = false, isCanvasEditable, page} = this.props;
        const WhiteBoardWrapperClasses = classNames({
            'white-board-wrapper': true,
            'student': isStudent()
        })

        return (
            <div className={WhiteBoardWrapperClasses}>
                <WhiteBoard
                    isTeacher={true}
                    width={width}
                    height={height}
                    imageUrl={imageUrl}
                    rotate={rotate}
                    canvas={canvas}
                    scale={canvas.scale || 1}
                    cancelCanvas={cancelCanvas}
                    isNotation={isNotation}
                    isCanvasEditable={isCanvasEditable}
                    page={page}
                    id={id}
                />
                <WhiteBoard
                    isTeacher={false}
                    width={width}
                    height={height}
                    imageUrl={imageUrl}
                    rotate={rotate}
                    canvas={canvas}
                    scale={canvas.scale || 1}
                    cancelCanvas={cancelCanvas}
                    isNotation={isNotation}
                    isCanvasEditable={isCanvasEditable}
                    page={page}
                    id={id}
                />
            </div>
        );
    }
}

export default WhiteBoardWrapper;
